import { combineReducers } from 'redux';



export default function (state = {}, action) {
  switch (action.type) {
    case 'EMSSerialInfoStore':
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}


